export const navItems = [
  { label: 'About', href: '/#about' },
  { label: 'Pillars', href: '/#principles' },
  { label: 'Philosophy', href: '/#philosophy' },
];

export const footerLinks = ['Home', 'About', 'The Formula', 'Ecosystem'];

export const legalLinks = [
  { label: 'Imprint', href: '/imprint' },
  { label: 'Privacy Policy', href: '/privacy' },
  { label: 'Cookie Policy', href: '/cookies' },
  { label: 'Terms of Use', href: '/terms' },
];

export const contactTopics = [
  { label: 'Partnership', note: 'Co-investment and joint ventures' },
  { label: 'Capital', note: 'Real estate and equity opportunities' },
  { label: 'Media', note: 'Press, interviews and features' },
  { label: 'Other', note: 'Anything else on your mind' },
];

export const office = {
  phone: '+971 50 525 4282',
  phoneHref: 'tel:+971505254282',
  address: ['Dubai Silicon Oasis, DDP, Building A1', 'Dubai, United Arab Emirates'],
};

export const contacts = [
  { label: 'General', email: 'info@kaysandkays.com' },
  { label: 'Media', email: 'media@kaysandkays.com' },
];
